var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page-component-container"},[_c('div',{staticClass:"component-wrapper"},[(!_vm.loggedInUser)?_c('LoginHeader'):_c('AppHeader'),_vm._m(0),(!_vm.loggedInUser)?_c('LoginFooter'):_c('AppFooter')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page-container"},[_c('p',[_vm._v("404 Not Found")])])
}]

export { render, staticRenderFns }